export default "__VITE_ASSET__73963057__"